const OTP_DEVICE_ID_KEY = "gomeet_otp_device_id";

export const getOtpDeviceId = () => {
  try {
    const existing = window.localStorage.getItem(OTP_DEVICE_ID_KEY);
    if (existing) return existing;

    const generated = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;

    window.localStorage.setItem(OTP_DEVICE_ID_KEY, generated);
    return generated;
  } catch (_) {
    return `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
};
